import React from "react";
import * as styles from "./rules-editor-section.module.scss";
import { classArr } from "../../../helper/style-helper";

export interface RulesEditorSectionProps {
	className?: string;
	children?: React.ReactNode;
	onClick?: () => void;
}

/**
 * An internal section card in the rules editor
 */
export default function RulesEditorSection(props: RulesEditorSectionProps) {
	return (
		<div
			className={classArr(props.className, styles.container)}
			onClick={props.onClick}
		>
			{props.children}
		</div>
	);
}
